// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1uOEY{height:64px;height:6.4rem}", ""]);
// Exports
exports.locals = {
	"externalDataSourceLogo": "_1uOEY"
};
module.exports = exports;
